import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { auth } from '../firebase';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

export default function AppProfile() {
  const navigate = useNavigate();
  const phone = localStorage.getItem('userPhone') || '';
  const name = localStorage.getItem('userName') || 'User';
  const [mySalon, setMySalon] = useState(null); // salon linked to this phone, if any

  useEffect(() => {
    // Securely check: does THIS phone own a salon? Only then show dashboard.
    const check = async () => {
      try {
        if (phone) {
          const r = await axios.get(`${API}/salon/by-phone/${phone}`, { timeout: 10000 });
          setMySalon(r.data?.salon || null);
        }
      } catch (e) { setMySalon(null); }
    };
    check();
  }, [phone]);

  const logout = () => {
    try { auth.signOut(); } catch (e) {}
    localStorage.clear();
    navigate('/app/login', { replace: true });
  };

  const Section = ({ title, items }) => (
    <>
      <div style={{ fontSize: 12, fontWeight: 800, color: GREY, padding: '14px 20px 8px', letterSpacing: '0.04em' }}>{title}</div>
      {items.map((it, i) => (
        <div key={i} onClick={it.onClick || (() => {})} style={{ background: '#fff', borderRadius: 14, padding: 16, display: 'flex', alignItems: 'center', gap: 14, margin: '0 16px 10px', cursor: 'pointer', boxShadow: '0 2px 8px rgba(28,28,40,.04)' }}>
          <span style={{ fontSize: 20, width: 24, textAlign: 'center' }}>{it.i}</span>
          <span style={{ fontSize: 14, fontWeight: 600, color: INK, flex: 1 }}>{it.t}</span>
          <span style={{ color: GREY, fontSize: 18 }}>›</span>
        </div>
      ))}
    </>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto', paddingBottom: 80 }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '26px 16px 22px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <div style={{ width: 58, height: 58, borderRadius: '50%', background: '#fff', color: RED, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, fontWeight: 800 }}>{name.charAt(0).toUpperCase()}</div>
        <div><div style={{ fontSize: 19, fontWeight: 800 }}>{name}</div><div style={{ fontSize: 13, opacity: 0.9, marginTop: 2 }}>+91 {phone}</div></div>
      </div>

      {/* Salon CTA — shows dashboard ONLY if this phone owns a salon (secure) */}
      {mySalon ? (
        <div onClick={() => {
          localStorage.setItem('salonId', mySalon.salon_id);
          navigate('/app/partner');
        }} style={{ background: 'linear-gradient(135deg,#1c1c28,#38384a)', color: '#fff', borderRadius: 18, padding: 20, margin: '12px 16px', cursor: 'pointer', position: 'relative', overflow: 'hidden' }}>
          <h4 style={{ fontSize: 17, fontWeight: 800 }}>💈 My Salon Dashboard</h4>
          <p style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>
            {mySalon.salon_name} · {mySalon.status === 'approved' ? 'Active' : 'Pending approval'}
          </p>
        </div>
      ) : (
        <div onClick={() => navigate('/app/list-salon')} style={{ background: 'linear-gradient(135deg,#1c1c28,#38384a)', color: '#fff', borderRadius: 18, padding: 20, margin: '12px 16px', cursor: 'pointer', position: 'relative', overflow: 'hidden' }}>
          <h4 style={{ fontSize: 17, fontWeight: 800 }}>💈 List Your Salon / Parlour</h4>
          <p style={{ fontSize: 12, opacity: 0.85, marginTop: 4, maxWidth: '80%' }}>Add your salon — 3 months FREE. Get online bookings.</p>
        </div>
      )}

      <Section title="MY ACTIVITY" items={[
        { i: '📅', t: 'My Bookings', onClick: () => navigate('/app/bookings') },
        { i: '♡', t: 'Saved Salons', onClick: () => navigate('/app/saved') },
        { i: '✨', t: 'Style Finder', onClick: () => navigate('/style-finder') },
        { i: '⭐', t: 'My Reviews', onClick: () => navigate('/app/reviews') },
      ]} />
      <Section title="ACCOUNT" items={[
        { i: '👤', t: 'Edit Profile', onClick: () => navigate('/app/edit-profile') },
        { i: '📍', t: 'Saved Addresses', onClick: () => navigate('/app/addresses') },
        { i: '🎁', t: 'Offers & Coupons', onClick: () => navigate('/app/offers') },
        { i: '🔔', t: 'Notifications', onClick: () => navigate('/app/notifications') },
      ]} />
      <Section title="MORE" items={[
        { i: '❓', t: 'Help & Support', onClick: () => navigate('/help') },
        { i: '📄', t: 'About · Privacy · Terms', onClick: () => navigate('/about') },
        { i: '🚪', t: 'Logout', onClick: logout },
      ]} />

      <div style={{ textAlign: 'center', padding: 16, color: GREY, fontSize: 11 }}>Made with ❤️ in India 🇮🇳 · v1.0</div>

      {/* bottom tabs */}
      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: 480, height: 68, background: '#fff', borderTop: '1px solid #f0f0f4', display: 'flex', zIndex: 30 }}>
        {[['🏠', 'Home', '/app/home'], ['🔍', 'Search', '/app/search'], ['📅', 'Bookings', '/app/bookings'], ['👤', 'Account', '/app/profile']].map(([ic, lbl, path], i) => (
          <div key={i} onClick={() => navigate(path)} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: 10, color: lbl === 'Account' ? RED : GREY, cursor: 'pointer', fontWeight: 600 }}>
            <span style={{ fontSize: 21 }}>{ic}</span>{lbl}
          </div>
        ))}
      </div>
    </div>
  );
}
